
namespace TabAurous.Inventory {
    import fld = ReOrderDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ReOrderDetailsGrid extends Serenity.EntityGrid<ReOrderDetailsRow, any> {
        protected getColumnsKey() { return 'Inventory.ReOrderDetails'; }
        protected getDialogType() { return ReOrderDetailsDialog; }
        protected getIdProperty() { return ReOrderDetailsRow.idProperty; }
        protected getInsertPermission() { return ReOrderDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ReOrderDetailsRow.localTextPrefix; }
        protected getService() { return ReOrderDetailsService.baseUrl; }
        static grid: Slick.Grid;
        private pendingChanges: Q.Dictionary<any> = {};

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }
        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            var plugin = new Slick.ColumnGroup();
            grid.registerPlugin(plugin);

            var columns = grid.getColumns();

            //grid.registerPlugin(new Slick.columng);

            for (let col of columns) {
                //console.log(col);
                if (col.field == "ProductCode" || col.field == "CategoryCode" || col.field == "ProductTypeCode" || col.field == "SubCategoryCode" || col.field == "FixedCode" ) col.groupName = "Details";

                if (col.field == "Minimum0" || col.field == "Maximum0") col.groupName = "Priority 1";
                if (col.field == "Minimum1" || col.field == "Maximum1") col.groupName = "Priority 2";
                if (col.field == "Minimum2" || col.field == "Maximum2") col.groupName = "Priority 3";
                if (col.field == "Update" || col.field == "Delete") col.groupName = "Options";
            }

            plugin.enableColumnGrouping();

            grid.setColumns(columns);
            return grid;
        }
        protected getButtons() {
            var btns = super.getButtons();
            btns.splice(Q.indexOf(btns, x => x.cssClass == "add-button"), 1);
            btns.push({
                title: 'New',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new ReOrderDetailCustomDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });
            return btns;
        }
        protected getColumns() {
            var columns = super.getColumns();
            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.Minimum0).format = num;
            Q.first(columns, x => x.field === fld.Maximum0).format = num;
            Q.first(columns, x => x.field === fld.Minimum1).format = num;
            Q.first(columns, x => x.field === fld.Maximum1).format = num;
            Q.first(columns, x => x.field === fld.Minimum2).format = num;
            Q.first(columns, x => x.field === fld.Maximum2).format = num;

            columns.push({
                field: 'Update',
                name: 'Update',
                format: ctx => '<a class="inline-action update-row" title="update">' +
                    '<i class="fa text-blue">Update</i></a>',
                width: 84,
                minWidth: 80,
                maxWidth: 100
            });
            columns.push({
                field: 'Delete',
                name: 'Delete',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red">Delete</i></a>',
                width: 84,
                minWidth: 80,
                maxWidth: 100
            });

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('update-row')) {
                    Q.confirm('Update record?', () => {
                        var x = item;
                        ReOrderDetailsService.Update({
                            Entity: item,
                            EntityId: item.DetailsId
                        }, response => {
                            this.refresh();
                        }
                        );
                        //Northwind.CustomerService.Delete({
                        //    EntityId: item.ID,
                        //}, response => {
                        //    this.refresh();
                        //});
                    });
                }
                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {
                        var x = item;
                        ReOrderDetailsService.Delete({
                            EntityId: item.DetailsId
                        }, response => {
                            this.refresh();
                        }
                        );
                        //Northwind.CustomerService.Delete({
                        //    EntityId: item.ID,
                        //}, response => {
                        //    this.refresh();
                        //});
                    });
                }

                else if (target.hasClass('view-details')) {
                    //    this.editItem(item.ID);
                }
                else if (target.hasClass('new-order')) {
                    //var dlg = new Northwind.OrderDialog();
                    //this.initDialog(dlg);
                    //dlg.loadEntityAndOpenDialog(<Northwind.OrderRow>{
                    //    CustomerID: item.CustomerID
                    //});
                }
            }
        }
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');

            var id = item.DetailsId;

            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            /*** Validate Decimal & Integer***/
            if (field === fld.Minimum0 || field === fld.Maximum0 || field === fld.Maximum1 || field === fld.Minimum1 || field === fld.Minimum2 || field === fld.Maximum2) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (field === fld.Minimum0 || field === fld.Maximum0 || field === fld.Maximum1 || field === fld.Minimum1 || field === fld.Minimum2 || field === fld.Maximum2) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            //// *** Update , Amount etc on  Change***
            if (field === fld.Minimum0 || field === fld.Maximum0 || field === fld.Maximum1 || field === fld.Minimum1 || field === fld.Minimum2 || field === fld.Maximum2) {


                item[field] = value;


                this.view.updateItem(id, item);
                this.view.refresh();
                //   }

            } else if (field === fld.Minimum0 || field === fld.Maximum0 || field === fld.Maximum1 || field === fld.Minimum1 || field === fld.Minimum2 || field === fld.Maximum2) {


                item[field] = value;


                this.view.updateItem(id, item);
                this.view.refresh();

            }
            //// *** Calculate Wastage ***
            //if (field === fld.WstPer && value >= 0) {
            //    item.WstWt = item.Net * (value / 100);
            //    item[field] = value;
            //}

            // *** Calculate Discount ***
            //if (field === fld.Discount && value >= 0) {
            //    item.GrossAmount = item.NetAmount - value;
            //    item[field] = value;

            //}

            // *** Set CalcOn ***
            if (field === fld.UOM && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }

        private getEffectiveValue(item, field: any): any {
            //var id = this.id(item);
            //var pending = this.pendingChanges[id];
            //if (pending && pending[field] !== undefined) {
            //    return pending[field];
            //}
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }
    }
}